import { Component } from '@angular/core';
import {HeroImagenesComponent} from "./hero-imagenes/hero-imagenes.component";
import {InfoImagenesComponent} from "./info-imagenes/info-imagenes.component";

@Component({
  selector: 'app-all-imagenes',
  standalone: true,
    imports: [
        HeroImagenesComponent,
        InfoImagenesComponent
    ],
  templateUrl: './all-imagenes.component.html',
  styleUrl: './all-imagenes.component.css'
})
export class AllImagenesComponent {

}
